import isDevelopment from '@/helpers/is-development'

let modules = [
    {
        fqn: 'oat-admin',
        url: () => require('./admin')
    },
    {
        fqn: 'oat-catalog',
        url: () => require('./catalog')
    },
    {
        fqn: 'oat-checkout',
        url: () => require('./checkout')
    },
    {
        fqn: 'oat-cms',
        url: () => require('./cms')
    }
];

export default modules
